<template>
  <div class="google-map"></div>
</template>

<script>

export default {
  name: 'google-map',
  props: ['position', 'center'],
  data: function () {
    return {}
  },
  watch: {
    position (newValue) {
      this.marker.setPosition(newValue)
      this.map.setCenter(newValue)
    },
    address (newValue) {
      this.map.setCenter(newValue)
    },
  },
  mounted: function () {
    // let scriptEl = document.createElement('script');
    // scriptEl.setAttribute('src', '');
    // this.$el.appendChild(scriptEl);

    const options = {
      zoom: 15,
      mapTypeControl: true,
      center: new google.maps.LatLng(-33.9, 151),
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_CENTER,
      },
      scaleControl: true,
    }
    this.map = new google.maps.Map(this.$el, options)
    this.marker = new google.maps.Marker({
      position: this.position,
      map: this.map,
      draggable: true,
    })

    this.marker.addListener('dragend', this.onMarkerDragEnd)
  },
  methods: {
    onMarkerDragEnd (event) {
      this.$emit('drag', { lat: event.latLng.lat(), lng: event.latLng.lng() })
    },
  },
}
</script>

<style scoped>
  .google-map {
    width: 100%;
    height: 425px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings/googleMap.vue